import { render, staticRenderFns } from "./ConversionsDetails.vue?vue&type=template&id=910743c8&scoped=true"
import script from "./ConversionsDetails.vue?vue&type=script&lang=js"
export * from "./ConversionsDetails.vue?vue&type=script&lang=js"
import style0 from "./ConversionsDetails.vue?vue&type=style&index=0&id=910743c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910743c8",
  null
  
)

export default component.exports